import {Tooltip} from "primereact/tooltip";
import {useId} from "react";
import {useTranslation} from "react-i18next";

import {CategoryTooltip} from "./LabelWithTooltip";

export default function DescriptionIcon({
    description,
    hasAssociatedOutputParam,
    originalValue,
    copyValue,
    type,
    categories,
}) {
    const tooltipId = useId().replaceAll(":", "-");
    const {t} = useTranslation();

    const hasCategories = type === "category" && Array.isArray(categories) && categories.length > 0;

    if (!description && !hasCategories) return null;

    const tooltipText = `${description ?? ""} ${
        hasAssociatedOutputParam ? `\n\n${t("object.associatedOutputParamHint")}` : ""
    } `;

    return (
        <>
            <Tooltip target={`#${tooltipId}`} className="custom-tooltip">
                {description && <div style={{whiteSpace: "pre-line"}}>{tooltipText}</div>}
                {hasCategories && (
                    <CategoryTooltip parameterData={{descriptionDe: null, descriptionEn: null, categories}} />
                )}
                {originalValue && (
                    <>
                        <div>
                            <br />
                            {t("value.nonRoundedValue") + originalValue}
                        </div>
                        <i>{t("value.actions.copyToClipboard")}</i>
                    </>
                )}
            </Tooltip>
            <i
                id={tooltipId}
                className="pi pi-question-circle tooltip-icon text-blue-500"
                data-pr-position="top"
                onClick={() => originalValue && copyValue(originalValue)}
            />
        </>
    );
}
